module.exports = __webpack_public_path__ + "img/colonnade.92ad0117.png";